import { Container } from 'pixi.js';
import { difficultyStyle } from './fileStyle';
import { GameEvent } from 'game/events/gameEvent';
import { EventName } from 'game/events/eventsName';
import { TranslationText } from './TranslationText';
import { Store } from 'game/store/gameStore';
import { MonoBehavior } from 'game/core/monoBehavior';
import { Layout } from 'game/LayoutManager';
import { Displays, DESKTOP_SIDEBAR_WIDTH } from 'constants/layout';

export class Difficulty extends MonoBehavior {
    private difficultyText: TranslationText;
    container: Container;
    constructor() {
        super();
        this.changeDifficulty = this.changeDifficulty.bind(this);
        this.container = new Container();

        this.difficultyText = new TranslationText(Store.getDifficultyText(), difficultyStyle);
        this.container.addChild(this.difficultyText.text);
        GameEvent.add(EventName.NEW_GAME, this.changeDifficulty);

        GameEvent.add(EventName.CHANGE_LANGUAGE, () => {
            setTimeout(() => this.resize(), 1);
        });
    }
    changeDifficulty(): void {
        this.difficultyText.setKey(Store.getDifficultyText());
    }
    resize(): void {
        const device = Layout.getDisplay();
        const startX = -Layout.getColumnPosition(0).x + Layout.getCardSize().width / 2;

        switch (device) {
            case Displays.DESKTOP:
                this.difficultyText.setAnchor(0.5);
                this.container?.position?.set(DESKTOP_SIDEBAR_WIDTH * 0.5, this.container.height * 0.5 + 43);
                break;
            case Displays.TABLET:
                this.difficultyText?.setAnchor(1, 0.5);
                this.container?.position?.set(startX, 19 + 4);

                break;
            case Displays.MOBILE:
                this.difficultyText?.setAnchor(1, 0.5);
                this.container?.position?.set(startX, 16 + 4);
                break;
        }
    }
}
